import React, { useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import InputCustom from 'src/components/common/field/InputCustom';
import DropDown from 'src/components/common/field/DropDown';
import BtnGradient from 'src/components/common/button/BtnGradient';
import dayjs from 'dayjs';

import { FilterType } from 'src/components/inventoryManagement/TypeCustom';

const currentDate = dayjs();

const sxlabelDropdown = {
  '&.Mui-focused': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
  '&.MuiInputLabel-root': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
};

const sizeDropdown = {
  width: '160px',
  height: '32px'
};

const defaultFilter = {
  month: currentDate.format('YYYY-MM'),
  product: ''
};

type SearchDataProps = {
  months: any[];
  isLoading?: boolean;
  onClickSearch: (filter: FilterType) => void;
};

const SearchData: React.FC<SearchDataProps> = (props) => {

  const [filter, setFilter] = useState<FilterType>(defaultFilter);

  const handleChangeFilter = (name: string) => (id: number | string | null) => {
    setFilter(prevState => ({
      ...prevState,
      [name]: id !== '' ? id : null
    }))
  };

  const handleSearch = () => {
    props.onClickSearch(filter);
  };

  return (
    <Stack
      direction={'row'}
      spacing='8px'
    >
      {!props.isLoading ? (
        <DropDown
          selected={filter.month}
          idSelect='month'
          placeholder='Month'
          onChange={handleChangeFilter('month')}
          sxInput={sizeDropdown}
          sxLabel={sxlabelDropdown}
          svgIconUrl='/images/ic-date-picker.svg'
          items={props.months}
        />
      ) : (
        <Box width={'160px'}>
          <Skeleton variant='rectangular' width={'160px'} height={'32px'} />
        </Box>
      )}

      {!props.isLoading ? (
        <InputCustom
          name='product'
          value={filter.product}
          onChange={handleChangeFilter('product')}
          type='text'
          labelInput='品名'
          sx={{ width: '320px', height: '32px', minHeight: '32px' }}
          sxInput={{ height: '0em' }}
        />
      ) : (
        <Skeleton variant='rectangular' width={'320px'} height={'32px'} />
      )}

      {!props.isLoading ? (
        <BtnGradient
          text='検索'
          handleButtonClick={handleSearch}
          sx={{
            minWidth: '60px',
            width: '60px',
          }}
        />
      ) : (
        <Box width={'60px'}>
          <Skeleton variant='rectangular' width={'60px'} height={'32px'} />
        </Box>
      )}
    </Stack>
  );
};

export default SearchData;
